import {
  voiceAnalyticsInputSchema,
  voiceAnalyticsOutputSchema,
} from "@redotech/redo-support-common/support/analytics/voice-analytics-schemas";

export const voiceAnalytics = {
  name: "voiceAnalytics" as const,
  input: voiceAnalyticsInputSchema,
  output: voiceAnalyticsOutputSchema,
};
